/* rastah-gwp-sync v8
   ============================================================
   Exact "A AND B required" Buy-2-Get-1 gift reconciler.

   v7: targeted drawer refresh (no innerHTML swap of the shell).
   v8 (NEVER CHARGE FOR A "FREE" GIFT):
     The metaobject offer decides WHEN a gift is added. It does NOT
     make it free -- the $0 comes from a matching Shopify automatic
     BXGY discount. If an offer exists in metaobjects with no
     matching discount, the gift was still added and the customer
     was CHARGED full price for it. That is what produced a cart
     reading "Gift unlocked -- added to your cart" with the cap
     billed at $65.
     Guard added:
       - after every reconcile, any gift line we own that has
         final_price > 0 is removed immediately and the offer is
         disabled for the rest of the session (pulled out of the
         config JSON in the DOM, so the promo UI stops advertising
         a gift that is not actually free).
       - a loud console.error names the offer so the missing
         discount can be created in Shopify admin.
     Also: the add circuit-breaker now resets whenever the gift is
     confirmed present, so a customer who removes and re-adds
     bundle products several times still gets the gift (previously
     the breaker could latch after two adds in one page load --
     the "sometimes the cap doesn't add" case).
   ============================================================ */
(function () {
  'use strict';

  var CFG_SEL = 'script[data-rastah-gwp-config]';
  var PROP = '_rastah_gwp';
  var MAX_ADDS = 3;
  var QC_HOST = '#shopify-section-quick-cart';
  var QC_PARTS = ['.quick-cart__items', '.quick-cart__footer', '.quick-cart__heading'];
  var addCount = {};
  var busy = false;
  var queued = false;

  window.__rastahGwpBlocked = window.__rastahGwpBlocked || [];

  function offers() {
    var el = document.querySelector(CFG_SEL);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  /* Disable an offer for this session by removing it from the config
     JSON both scripts read on every pass. */
  function blockOffer(handle) {
    if (window.__rastahGwpBlocked.indexOf(handle) === -1) window.__rastahGwpBlocked.push(handle);
    var el = document.querySelector(CFG_SEL);
    if (!el) return;
    try {
      var list = JSON.parse(el.textContent) || [];
      var next = list.filter(function (x) { return x.handle !== handle; });
      if (next.length !== list.length) el.textContent = JSON.stringify(next);
    } catch (e) {}
    document.querySelectorAll('[data-gwp-offer="' + handle + '"]').forEach(function (n) { n.remove(); });
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function hasOurTag(it) {
    return !!(it.properties && Object.prototype.hasOwnProperty.call(it.properties, PROP));
  }

  function addGift(o) {
    var props = {};
    props[PROP] = o.handle;
    console.info('[rastah-gwp] adding gift', o.handle, 'variant', o.gift.variant);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: o.gift.variant, quantity: o.gift_qty || 1, properties: props })
    }).then(function (r) {
      if (r && !r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          window.__rastahGwpLastError = {
            status: r.status,
            message: (j && (j.description || j.message)) || '',
            variant: o.gift.variant,
            offer: o.handle,
            ts: Date.now()
          };
          console.warn('[rastah-gwp] gift add failed', r.status, j);
        });
      }
    }).catch(function (err) {
      window.__rastahGwpLastError = { status: 0, message: String(err && err.message || err), variant: o.gift.variant, offer: o.handle, ts: Date.now() };
      console.warn('[rastah-gwp] gift add network error', err);
    });
  }

  function removeLine(key, reason) {
    console.info('[rastah-gwp] removing gift line', key, '-', reason || 'offer no longer qualifies');
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(function () { /* never break the host cart flow */ });
  }

  /* Targeted re-render of the drawer's inner content only. */
  function refreshDrawer() {
    try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); } catch (e) {}
    var host = document.querySelector(QC_HOST);
    if (!host) return Promise.resolve();
    return fetch('/?section_id=quick-cart', {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      QC_PARTS.forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var live = host.querySelector(sel);
        if (!fresh || !live) return;
        if (fresh.innerHTML === live.innerHTML) return;
        live.innerHTML = fresh.innerHTML;
      });
      try {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('quick-cart:updated'));
      } catch (e) {}
    }).catch(function () { /* never break the host cart flow */ });
  }

  function reconcile() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    var list = offers();
    if (!list.length) { busy = false; return Promise.resolve(); }

    return getCart().then(function (cart) {
      var chain = Promise.resolve();
      var changed = false;

      list.forEach(function (o) {
        if (window.__rastahGwpBlocked.indexOf(o.handle) !== -1) return;

        var hasA = false, hasB = false, giftLine = null, giftIsOurs = false;
        var giftProductId = o.gift && o.gift.id;

        cart.items.forEach(function (it) {
          if (hasOurTag(it)) {
            var tag = it.properties[PROP];
            if (tag === o.handle || tag == null) {
              if (!giftLine || tag === o.handle) { giftLine = it; giftIsOurs = true; }
              return;
            }
            return; /* another offer's gift -- never a buy-product */
          }
          if (giftProductId && it.product_id === giftProductId) {
            if (!giftLine) giftLine = it;
            return;
          }
          if (it.product_id === o.buy_a.id) hasA = true;
          if (it.product_id === o.buy_b.id) hasB = true;
        });

        var qualifies = hasA && hasB;

        /* v8: a gift we added that is NOT free means no Shopify
           discount covers this offer. Pull it before the customer
           pays for it, and stop advertising it. */
        if (giftLine && giftIsOurs && giftLine.final_price > 0) {
          console.error('[rastah-gwp] offer "' + o.handle + '": gift "' + o.gift.title +
            '" is being CHARGED ' + (giftLine.final_price / 100) +
            ' - no active Shopify automatic discount covers it. Removing the line and disabling this offer for the session.');
          blockOffer(o.handle);
          changed = true;
          var badKey = giftLine.key;
          chain = chain.then(function () { return removeLine(badKey, 'gift was not discounted to zero'); });
          return;
        }

        if (giftLine) addCount[o.handle] = 0; /* confirmed present -- reset breaker */

        if (qualifies && !giftLine) {
          if ((addCount[o.handle] || 0) >= MAX_ADDS) {
            console.warn('[rastah-gwp] add circuit-breaker tripped for', o.handle,
              '- gift was added', MAX_ADDS, 'times but never stayed in the cart.');
            return;
          }
          addCount[o.handle] = (addCount[o.handle] || 0) + 1;
          changed = true;
          chain = chain.then(function () { return addGift(o); });
        } else if (!qualifies && giftLine && giftIsOurs) {
          changed = true;
          var key = giftLine.key;
          var reason = 'hasA=' + hasA + ' hasB=' + hasB + ' (a buy-product left the cart)';
          chain = chain.then(function () { return removeLine(key, reason); });
        }
      });

      return chain.then(function () { if (changed) return refreshDrawer(); });
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; return reconcile(); }
    });
  }

  /* Observe cart mutations from any script in the theme. */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = _fetch.apply(this, arguments);
    if (CART_RE.test(url) && !busy) {
      p.then(function (res) {
        setTimeout(reconcile, 150);
        return res;
      }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  } else {
    setTimeout(reconcile, 400);
  }

  window.rastahGwpSync = reconcile;
  window.rastahGwpRefreshDrawer = refreshDrawer;
  window.__rastahGwpResetBreaker = function () { addCount = {}; };
})();
